// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21.9395 3H2.06055L0.935547 21H7.72076L8.72076 18H15.2792L16.2792 21H23.0645L21.9395 3ZM11 9.5V11.5H9V13.5H7L7 11.5L5 11.5V9.5H7V7.5H9V9.5L11 9.5ZM16 7.5H18.0039V9.50391H16V7.5ZM18.0039 11.4961V13.5H16V11.4961H18.0039Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-gamepad-filled')
export default class GamepadFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'gamepad-filled',
    }
  }
}
